import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-col">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/xqb7fx6c_naru%20tofu%20logo.jpg" 
                alt="Naru Tofu" 
                className="footer-logo"
              />
            </Link>
            <p className="body-small" style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>
              {companyInfo.tagline}
            </p>
          </div>
          
          <div className="footer-col">
            <h4 className="body-regular" style={{ marginBottom: '16px', fontWeight: '600' }}>Company</h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              {companyInfo.name}
            </p>
            <p className="body-small" style={{ marginTop: '8px', color: 'var(--text-secondary)' }}>
              GST: {companyInfo.billing.gst}
            </p>
          </div>
          
          <div className="footer-col">
            <h4 className="body-regular" style={{ marginBottom: '16px', fontWeight: '600' }}>Office</h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              {companyInfo.billing.address}
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            © {new Date().getFullYear()} Naru Tofu Organics Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
